import { useState } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import PageHeader from "@/components/feature/PageHeader";

const SUBMIT_ADDR = "https://readdy.ai/api/form/da1vrnrk8r5te5mqsckg";

const contactCards = [
  { icon: "ri-mail-send-line", title: "邮箱咨询", desc: "service@dingdongmanga.com" },
  { icon: "ri-wechat-line", title: "官方公众号", desc: "叮咚漫画网" },
  { icon: "ri-time-line", title: "工作时间", desc: "每日 09:00 - 23:00" },
  { icon: "ri-chat-3-line", title: "意见反馈", desc: "欢迎随时留言建议" },
];

export default function Contact() {
  const [status, setStatus] = useState<"idle" | "success" | "error">("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const data = new FormData(form);
    const honeypot = (data.get("phone_alt") as string) || "";
    if (honeypot.trim()) {
      setStatus("success");
      setMessage("留言已收到，我们会尽快与你联系！");
      form.reset();
      return;
    }
    const payload = new URLSearchParams();
    data.forEach((value, key) => {
      if (key !== "phone_alt" && value) payload.append(key, value as string);
    });
    try {
      const res = await fetch(SUBMIT_ADDR, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });
      const responseText = await res.text();
      let parsed: Record<string, unknown> | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const meta = (parsed?.meta as Record<string, unknown>) || null;
      const code = parsed?.code;
      const serverMsg = (meta?.message as string) || (parsed?.message as string) || (meta?.detail as string) || responseText;
      if (res.ok && code === "OK" && !/spam/i.test(serverMsg)) {
        setStatus("success");
        setMessage("留言已收到，我们会尽快与你联系！");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "提交失败，请稍后重试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后重试。");
    }
  };

  return (
    <>
      <Navbar />
      <PageHeader
        crumbs={[
          { label: "首页", to: "/" },
          { label: "联系我们" },
        ]}
        title="联系我们"
        desc="无论是作品合作、版权洽谈、读者反馈还是新作投稿，欢迎通过下方表单或联系方式与叮咚漫画网取得联系。"
      />
      <main className="bg-background-50 py-12 md:py-16">
        <div className="mx-auto max-w-7xl px-4 md:px-6">
          <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4 md:gap-5">
            {contactCards.map((c) => (
              <div key={c.title} className="rounded-xl bg-background-100 border border-background-200 p-5 text-center">
                <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-primary-500 text-2xl text-background-50">
                  <i className={c.icon} />
                </span>
                <h2 className="mt-3 font-heading text-base font-bold text-foreground-900">{c.title}</h2>
                <p className="mt-1 text-sm text-foreground-600">{c.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-10 grid gap-8 lg:grid-cols-5 lg:gap-12">
            <div className="lg:col-span-2">
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">留言给我们</h2>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                我们非常重视每一位读者的声音。你的建议、反馈或合作意向，都会第一时间送达编辑团队。填写左侧表单，或通过邮箱与我们联系。
              </p>
              <div className="mt-6 rounded-xl border border-background-200 bg-background-100 p-5">
                <p className="text-sm font-semibold text-foreground-900">投稿与合作</p>
                <p className="mt-1 text-sm text-foreground-600">
                  如果你是一位创作者或版权方，欢迎把你的新作投稿给叮咚漫画网，一起把好作品带给更多读者。
                </p>
                <p className="mt-3 text-sm font-medium text-primary-600">cooperate@dingdongmanga.com</p>
              </div>
            </div>

            <form
              data-readdy-form="da1vrnrk8r5te5mqsckg"
              onSubmit={handleSubmit}
              className="rounded-2xl border border-background-200 bg-background-50 p-6 md:p-8 lg:col-span-3"
            >
              <div className="grid gap-5 sm:grid-cols-2">
                <div>
                  <label htmlFor="name" className="mb-2 block text-sm font-semibold text-foreground-800">您的称呼</label>
                  <input
                    id="name"
                    name="name"
                    type="text"
                    required
                    maxLength={50}
                    placeholder="请输入您的称呼"
                    className="w-full rounded-lg border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
                  />
                </div>
                <div>
                  <label htmlFor="email" className="mb-2 block text-sm font-semibold text-foreground-800">联系邮箱</label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    required
                    maxLength={200}
                    placeholder="请输入您的邮箱"
                    className="w-full rounded-lg border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
                  />
                </div>
                <div className="sm:col-span-2">
                  <label htmlFor="subject" className="mb-2 block text-sm font-semibold text-foreground-800">留言主题</label>
                  <select
                    id="subject"
                    name="subject"
                    defaultValue="读者反馈"
                    className="w-full rounded-lg border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
                  >
                    <option>读者反馈</option>
                    <option>作品合作</option>
                    <option>版权洽谈</option>
                    <option>新作投稿</option>
                    <option>其他咨询</option>
                  </select>
                </div>
                <div className="sm:col-span-2">
                  <label htmlFor="content" className="mb-2 block text-sm font-semibold text-foreground-800">留言内容</label>
                  <textarea
                    id="content"
                    name="content"
                    required
                    maxLength={500}
                    rows={5}
                    placeholder="请描述您的想法、建议或需求（500 字以内）"
                    className="w-full resize-none rounded-lg border border-background-300 bg-background-50 px-4 py-2.5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400"
                  />
                </div>
                <input
                  type="text"
                  name="phone_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                />
              </div>

              {status === "success" && (
                <p className="mt-4 flex items-center gap-2 rounded-lg bg-accent-100 px-4 py-3 text-sm text-accent-800" role="status">
                  <i className="ri-checkbox-circle-fill" /> {message}
                </p>
              )}
              {status === "error" && (
                <p className="mt-4 flex items-center gap-2 rounded-lg bg-red-50 px-4 py-3 text-sm text-red-600" role="alert">
                  <i className="ri-error-warning-fill" /> {message}
                </p>
              )}

              <button
                type="submit"
                className="mt-5 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:w-auto"
              >
                <i className="ri-send-plane-line" /> 提交留言
              </button>
            </form>
          </div>
        </div>
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            name: "联系叮咚漫画网",
            description: "联系叮咚漫画网，进行读者反馈、作品合作、版权洽谈与新作投稿。",
            url: "https://fangupdate.github.io/contact",
            inLanguage: "zh-CN",
            isPartOf: { "@type": "WebSite", name: "叮咚漫画网", url: "https://fangupdate.github.io/" },
          }),
        }}
      />
    </>
  );
}